export default "__VITE_ASSET__1Z$kx2HB__"